import { RootState as RS } from "../types";
import { GlobalStateType } from "./types";

const getGlobalStateSlice = (state: RS): GlobalStateType => state.globalState;

export const getActivePageName = (state: RS): string =>
  getGlobalStateSlice(state).activePageName;
